// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Xv2","content":"styles_content__12qEt"};